import { useState, useCallback } from 'react';

export const useTermsAcceptance = () => {
    const [termsAccepted, setTermsAccepted] = useState(true);

    const handleTermsAccept = useCallback(() => {
        setTermsAccepted((prev) => !prev);
    }, []);

    return { termsAccepted, handleTermsAccept };
};
